import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { AddressForm as BillingAddressForm } from '@bingads-webui-cc-react/address-form';
import { InputFormGroup } from '@bingads-webui-cc-react/layout';

export class CheckBankTransferForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: props.address,
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!_.isEqual(nextProps.address, this.props.address)) {
      this.setState({ address: nextProps.address, isAddressValid: false });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState, this.state)) {
      this.props.onFormValidate(this.state.address, this.state.isAddressValid);
    }
  }

  onAddressChange = (addressModel, addressObject) => {
    if (addressModel && addressModel.Country.value) {
      this.setState({ address: addressObject, isAddressValid: addressModel.isValid });
    }
  };

  render() {
    const {
      id,
      i18n,
      countries,
      findCountries,
      findStates,
    } = this.props;

    const formGroupId = `${id}-biling-address-form-group`;
    return (
      <div className="check-bank-transfer-form" id={id}>
        <InputFormGroup
          id={formGroupId}
          labelColClass="col-xs-12"
          contentColClass="col-xs-12"
          name={`${id}_BillingAddressSection`}
          label={i18n.getString(_TL_('Billing address'))}
        >
          <BillingAddressForm
            id={`${id}_BillingAddressForm`}
            i18n={i18n}
            countries={countries}
            findCountries={findCountries}
            findStates={findStates}
            model={this.props.address}
            onAddressChange={this.onAddressChange}
            showSectionLabel
            hideSingleCountry
            useDropdownList
            showLineByLineFormGroup
            showPlaceholder
            formGroupId={formGroupId}
          />
        </InputFormGroup>
      </div>
    );
  }
}

CheckBankTransferForm.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  id: PropTypes.string.isRequired,
  findCountries: PropTypes.func.isRequired,
  findStates: PropTypes.func.isRequired,
  address: PropTypes.shape({
    Line1: PropTypes.string,
    Line2: PropTypes.string,
    City: PropTypes.string,
    StateOrProvince: PropTypes.string,
    PostalCode: PropTypes.string,
    Country: PropTypes.string,
  }),
  onFormValidate: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    Code: PropTypes.string.isRequired,
    Name: PropTypes.string.isRequired,
  })).isRequired,
};

CheckBankTransferForm.defaultProps = {
  address: {},
};
